import { createAction, props } from '@ngrx/store';
import { SelfPublishTag } from 'src/app/modules/companies/companies.interface';

const TAGS_REQUEST = '[Tags Request/Api]';
const TAGS_REDUCER = '[Tags Reducer]';

export const request = {
  loadTags: createAction(`${TAGS_REQUEST} Load Tags`),
  createTag: createAction(`${TAGS_REQUEST} Create Tag`, props<Omit<SelfPublishTag, 'id'>>()),
  patchTag: createAction(`${TAGS_REQUEST} Patch Tag`, props<SelfPublishTag>()),
  deleteTag: createAction(`${TAGS_REQUEST} Delete Tag`, props<Pick<SelfPublishTag, 'id'>>())
};

export const setTags = createAction(`${TAGS_REDUCER} Set Tags`, props<{ tags: SelfPublishTag[] }>());

export const addTag = createAction(`${TAGS_REDUCER} Add Tag`, props<{ tag: SelfPublishTag }>());

export const updateTag = createAction(`${TAGS_REDUCER} Update Tag`, props<{ tag: SelfPublishTag }>());

export const deleteTag = createAction(`${TAGS_REDUCER} Delete Tag`, props<{ id: SelfPublishTag['id'] }>());
